import { combineReducers } from 'redux';

import accountProfileReducer from './accountProfile/accountProfileReducer';
import accountActivationReducer from './AccountActivation/account-activation-reducer';

export default combineReducers({
  profile: accountProfileReducer,
  activation: accountActivationReducer,
});



// WEBPACK FOOTER //
// ./src/features/Account/accountReducer.js